import React from "react";
import { Table } from "semantic-ui-react";
import {
  getDescripcionMoneda,
  getDescripcionMetodoPago,
} from "../../../../app/util/textCodeUtils";
import PropTypes from "prop-types";
import { formatMoney } from "../../../../app/util/formatUtils";
import { CODIGO_METODO_PAGO_CUENTA_AHORROS } from "../../../../app/infrastructure/appConstants";

const PagarPrestamosResumenInfo = ({
  numeroPrestamo,
  montoCuotas,
  itf,
  totalPagar,
  codigoMonedaPrestamo,
  metodoPago,
  cargoCuenta,
}) => {
  return (
    <>
      <Table basic="very" size="large">
        <Table.Body className="presentacionTable">
          <Table.Row>
            <Table.Cell>Crédito:</Table.Cell>
            <Table.Cell>{numeroPrestamo}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Monto cuota(s):</Table.Cell>
            <Table.Cell>{`${formatMoney(montoCuotas.toFixed(2))}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>ITF:</Table.Cell>
            <Table.Cell>{`${formatMoney(itf.toFixed(2))}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Total a pagar:</Table.Cell>
            <Table.Cell>{`${formatMoney(totalPagar.toFixed(2))}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Moneda:</Table.Cell>
            <Table.Cell>
              {getDescripcionMoneda(codigoMonedaPrestamo)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Método de pago:</Table.Cell>
            <Table.Cell>{getDescripcionMetodoPago(metodoPago)}</Table.Cell>
          </Table.Row>
          {metodoPago === CODIGO_METODO_PAGO_CUENTA_AHORROS && (
            <Table.Row>
              <Table.Cell>Cargo cuenta:</Table.Cell>
              <Table.Cell>{cargoCuenta}</Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </>
  );
};

PagarPrestamosResumenInfo.propTypes = {
  numeroPrestamo: PropTypes.number.isRequired,
  montoCuotas: PropTypes.number.isRequired,
  itf: PropTypes.number.isRequired,
  totalPagar: PropTypes.number.isRequired,
  codigoMonedaPrestamo: PropTypes.string.isRequired,
  metodoPago: PropTypes.string.isRequired,
  cargoCuenta: PropTypes.string,
};

export default PagarPrestamosResumenInfo;
